import * as React from 'react';

/** Material UI Packages. */
import { Menu, MenuItem } from '@mui/material';

/** Internal Components. */
import { customized_style } from 'shared/config/Styles';

/** Client-side routing Library.  */
import { Link } from 'react-router-dom';

/**
 * Renders a dropdown submenu.
 * @param {HTMLElement} props.anchorEl - HTML element used to position the menu (the anchor element).
 * @param {boolean} props.open - Determine if the menu is open or closed.
 * @param {Function} props.handleClose -  Handle to close a menu list.
 * @param {Array} props.menuItems - Menu items to be displayed in the submenu.
 * @returns {JSX.Element} Menu component with a list of clickable MenuItems.
 *
 */
const SubMenu = ({ anchorEl, open, handleClose, menuItems, linkItems, handleItemClick, name }) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            sx={{
                '& .MuiButtonBase-root': {
                    px: 1,
                    '&:hover': {
                        backgroundColor: 'rgba(0, 101, 126, 0.3)',
                    },
                },
            }}
        >
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    sx={customized_style.itemSubMenu}
                    component={Link}
                    to={`/${linkItems[index]}`}
                    onClick={() => {
                        handleItemClick(name);
                        handleClose();
                    }}
                >
                    {item}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default SubMenu;
